import React from 'react';
import { useNavigate, useSearchParams, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import Calendar from 'react-calendar';

import Layout from 'components/Layout';
import TopBar from 'components/TopBar';
import { getGameId, getStartDate, getToday } from 'common/logic';
import { useGameDataHistory } from 'common/hooks';

function PreviousListScreen() {
  const navigate = useNavigate();
  const { language } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const { getGameData } = useGameDataHistory();
  const { t } = useTranslation();

  const minDate = getStartDate(language).toDate();
  const maxDate = getToday().toDate();

  const onClickDay = (date) => {
    const formattedDate = dayjs(date).format('YYYY-MM-DD');
    navigate(`/${language}/previous/${formattedDate}`);
  };

  const monthFromParams = searchParams.get('month');
  const defaultActiveStartDate = monthFromParams
    ? dayjs(monthFromParams).toDate()
    : new Date();

  const tileContent = ({ date, view }) => {
    if (
      view === 'month' &&
      date.getDate() === minDate.getDate() &&
      date.getMonth() === minDate.getMonth() &&
      date.getYear() === minDate.getYear()
    ) {
      return <t>*</t>;
    }
    return null;
  };

  const titleClassName = ({ date, view }) => {
    if (view === 'month') {
      const formattedDate = dayjs(date).format('YYYY-MM-DD');
      const gameId = getGameId(formattedDate, language);
      const gameData = getGameData(gameId, language);
      if (!gameData) return null;
      if (gameData.status === 'won') return 'game-won';
      if (gameData.attempts.length > 0) return 'game-started';
      return null;
    }
  };

  const locales = {
    pt: 'pt-BR',
    es: 'es-ES',
    en: 'en-US',
  };

  const locale = locales[language] || 'en-US';

  return (
    <Layout>
      <TopBar title={<div className="game-title">Letroso</div>} />
      <div style={{ fontSize: 22, fontWeight: 'bold', paddingBottom: 10 }}>
        {t('previousGamesScreen.title')}
      </div>
      <div style={{ maxWidth: 500 }}>
        <Calendar
          locale={locale}
          minDate={minDate}
          maxDate={maxDate}
          minDetail="year"
          showNeighboringMonth={false}
          prev2Label={null}
          next2Label={null}
          onClickDay={onClickDay}
          defaultActiveStartDate={defaultActiveStartDate}
          onActiveStartDateChange={({ action, activeStartDate, view }) => {
            if (view === 'month' && action !== 'onChange') {
              setSearchParams(
                {
                  ...searchParams,
                  month: dayjs(activeStartDate).format('YYYY-MM'),
                },
                { replace: true },
              );
            }
          }}
          tileClassName={titleClassName}
          tileContent={tileContent}
        />

        {minDate.getMonth() === defaultActiveStartDate.getMonth() &&
          minDate.getFullYear() === defaultActiveStartDate.getFullYear() && (
            <div
              style={{
                fontSize: 14,
                marginTop: '20px',
                padding: '10px',
                textAlign: 'center',
              }}
            >
              * {t('previousGamesScreen.firstGame')}
            </div>
          )}
      </div>
    </Layout>
  );
}

export default PreviousListScreen;
